// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-beni-taniyin-js": function componentSrcPagesBeniTaniyinJs() {
    return import("./../../src/pages/BeniTaniyin.js"
    /* webpackChunkName: "component---src-pages-beni-taniyin-js" */
    );
  },
  "component---src-pages-email-list-js": function componentSrcPagesEmailListJs() {
    return import("./../../src/pages/EmailList.js"
    /* webpackChunkName: "component---src-pages-email-list-js" */
    );
  },
  "component---src-pages-iletisim-js": function componentSrcPagesIletisimJs() {
    return import("./../../src/pages/Iletisim.js"
    /* webpackChunkName: "component---src-pages-iletisim-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-page-comp-carousel-js": function componentSrcPagesPageCompCarouselJs() {
    return import("./../../src/pages/pageComp/Carousel.js"
    /* webpackChunkName: "component---src-pages-page-comp-carousel-js" */
    );
  },
  "component---src-pages-page-comp-footer-email-js": function componentSrcPagesPageCompFooterEmailJs() {
    return import("./../../src/pages/pageComp/FooterEmail.js"
    /* webpackChunkName: "component---src-pages-page-comp-footer-email-js" */
    );
  },
  "component---src-pages-page-comp-image-and-text-js": function componentSrcPagesPageCompImageAndTextJs() {
    return import("./../../src/pages/pageComp/ImageAndText.js"
    /* webpackChunkName: "component---src-pages-page-comp-image-and-text-js" */
    );
  },
  "component---src-pages-page-comp-profile-card-js": function componentSrcPagesPageCompProfileCardJs() {
    return import("./../../src/pages/pageComp/ProfileCard.js"
    /* webpackChunkName: "component---src-pages-page-comp-profile-card-js" */
    );
  },
  "component---src-pages-satin-alma-islemleri-js": function componentSrcPagesSatinAlmaIslemleriJs() {
    return import("./../../src/pages/SatinAlmaIslemleri.js"
    /* webpackChunkName: "component---src-pages-satin-alma-islemleri-js" */
    );
  },
  "component---src-pages-satis-islemleri-js": function componentSrcPagesSatisIslemleriJs() {
    return import("./../../src/pages/SatisIslemleri.js"
    /* webpackChunkName: "component---src-pages-satis-islemleri-js" */
    );
  },
  "component---src-pages-toronto-semtleri-js": function componentSrcPagesTorontoSemtleriJs() {
    return import("./../../src/pages/TorontoSemtleri.js"
    /* webpackChunkName: "component---src-pages-toronto-semtleri-js" */
    );
  },
  "component---src-pages-yabanci-yatirimcilar-js": function componentSrcPagesYabanciYatirimcilarJs() {
    return import("./../../src/pages/YabanciYatirimcilar.js"
    /* webpackChunkName: "component---src-pages-yabanci-yatirimcilar-js" */
    );
  }
};